import axios from "axios";

export const tagBindDeviceAPI = async (tags = [], device_id) => {
  let tag_ids = typeof tags[0] === "string" ? tags : tags.map(e => e.id);
  let response = await axios({
    url: `/api/v2/tag/bind-device`,
    method: "POST",
    data: {
      tag_ids,
      device_id: Array.isArray(device_id) ? undefined : device_id,
      device_ids: Array.isArray(device_id) ? device_id : undefined
    }
  });
  return response.data;
};
